import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, unref as _unref, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "login-section" }
const _hoisted_2 = { class: "login-container" }
const _hoisted_3 = { class: "login-header" }
const _hoisted_4 = {
  key: 0,
  class: "login-loading"
}
const _hoisted_5 = {
  key: 1,
  class: "login-warning"
}

import { ref } from 'vue';
import { useRouter } from 'vue-router';
import { MailOutlined, LockOutlined } from '@ant-design/icons-vue';
import LoadingSpinner from '@/components/LoadingSpinner.vue';
import { Auth } from '@/lib/auth';
import Cookies from 'js-cookie';


export default /*@__PURE__*/_defineComponent({
  __name: 'Login',
  setup(__props) {

const form = ref({
  email: '',
  password: '',
});

const isInProcess = ref(false);
const isWarning = ref(false);
const message = ref('');
const router = useRouter();

const login = async () => {
  isInProcess.value = true;
  isWarning.value = false;
  message.value = '';

  try {
    const result = await Auth.login({
      email: form.value.email,
      password: form.value.password,
    })
    if (result.accessToken) {
      Cookies.set('accessToken', result.accessToken)
      router.push('/');
    } else {
      isWarning.value = true;
      message.value = result.error || 'Login failed.';
    }

  } catch (err: any) {
    isWarning.value = true;
    console.log('Login error:', err.response);

    if (err.response && err.response.data && err.response.data.error) {
      message.value = err.response.data.error;
    } else if (err.message) {
      message.value = err.message;
    } else {
      message.value = 'メールアドレスとパスワードは必須です。';
    }
  } finally {
    isInProcess.value = false;
  }
};


return (_ctx: any,_cache: any) => {
  const _component_a_typography_title = _resolveComponent("a-typography-title")!
  const _component_a_typography_text = _resolveComponent("a-typography-text")!
  const _component_a_input = _resolveComponent("a-input")!
  const _component_a_form_item = _resolveComponent("a-form-item")!
  const _component_a_input_password = _resolveComponent("a-input-password")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_form = _resolveComponent("a-form")!

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _cache[4] || (_cache[4] = _createStaticVNode("<svg width=\"25\" height=\"24\" viewBox=\"0 0 25 24\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" data-v-b5eae738><rect x=\"0.464\" width=\"24\" height=\"24\" rx=\"4.8\" fill=\"#1890FF\" data-v-b5eae738></rect><path d=\"M14.864 3.6H20.864V9.6H14.864V3.6Z\" fill=\"white\" data-v-b5eae738></path><path d=\"M10.064 9.6H14.864V14.4H10.064V9.6Z\" fill=\"white\" data-v-b5eae738></path><path d=\"M4.064 13.2H11.264V20.4H4.064V13.2Z\" fill=\"white\" data-v-b5eae738></path></svg>", 1)),
        _createVNode(_component_a_typography_title, {
          class: "login-title",
          level: 2
        }, {
          default: _withCtx(() => _cache[2] || (_cache[2] = [
            _createTextVNode("Login", -1)
          ])),
          _: 1,
          __: [2]
        }),
        _createVNode(_component_a_typography_text, { class: "login-text" }, {
          default: _withCtx(() => _cache[3] || (_cache[3] = [
            _createTextVNode(" Welcome back! Please enter your information to login ", -1)
          ])),
          _: 1,
          __: [3]
        })
      ]),
      (isInProcess.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
            _createVNode(LoadingSpinner, { color: "#1890FF" })
          ]))
        : _createCommentVNode("", true),
      (isWarning.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_5, _toDisplayString(message.value), 1))
        : _createCommentVNode("", true),
      _createVNode(_component_a_form, {
        layout: "vertical",
        model: form.value,
        onFinish: login
      }, {
        default: _withCtx(() => [
          _createVNode(_component_a_form_item, {
            label: "メールアドレス",
            name: "email",
            rules: [{ required: true, type: 'email', message: 'Please enter your email!' }]
          }, {
            default: _withCtx(() => [
              _createVNode(_component_a_input, {
                value: form.value.email,
                "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((form.value.email) = $event)),
                placeholder: "Email"
              }, {
                prefix: _withCtx(() => [
                  _createVNode(_unref(MailOutlined))
                ]),
                _: 1
              }, 8, ["value"])
            ]),
            _: 1
          }),
          _createVNode(_component_a_form_item, {
            label: "パスワード",
            name: "password",
            rules: [{ required: true, message: 'Please enter your password!' }]
          }, {
            default: _withCtx(() => [
              _createVNode(_component_a_input_password, {
                value: form.value.password,
                "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((form.value.password) = $event)),
                placeholder: "Password"
              }, {
                prefix: _withCtx(() => [
                  _createVNode(_unref(LockOutlined))
                ]),
                _: 1
              }, 8, ["value"])
            ]),
            _: 1
          }),
          _createVNode(_component_a_form_item, null, {
            default: _withCtx(() => [
              _createVNode(_component_a_button, {
                block: "",
                type: "primary",
                "html-type": "submit",
                loading: isInProcess.value
              }, {
                default: _withCtx(() => _cache[5] || (_cache[5] = [
                  _createTextVNode("Login", -1)
                ])),
                _: 1,
                __: [5]
              }, 8, ["loading"])
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["model"])
    ])
  ]))
}
}

})